import { styled } from '@innowise-group/mui-kit';

export const Header = styled.div`
  ${({ theme }) => theme.fonts.primary[90]};
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
`;

export const Spacer = styled.div`
  height: 1.5rem;
`;
